import { registerI18nResources } from '@mc/i18n'
import { CHECKOUT_I18N_NAMESPACE } from './constants'
import enUS from './locales/en-US.json'

export const i18nInstance = registerI18nResources({
  namespace: CHECKOUT_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
